import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePlansStore = defineStore('plans', () => {
    const allPlans = ref([]);
    const availablePlans = ref([]);

    const actions = {

    };

    const reset = () => {
        allPlans.value = [];
        availablePlans.value = [];
    };

    return { 
        allPlans,
        availablePlans,
        ...actions,
        reset,
    };
});
